/**
 * Main Application Entry Point
 *
 * @package oska
 */

import initBurgerNav from "./components/burger-nav";
import initCustomSelect from "./components/custom-select";
import initSectorDropdown from "./components/sector-dropdown";
import initPrevNextNav from "./components/prev-next-nav";
import initProposalCard from "./components/proposal-card";
import initProposalItem from "./components/proposal-item";
import initCardsProgress from "./components/cards-progress";
import initScrollingCards from "./components/scrolling-cards";
import initDonutCharts from "./components/donut-chart";
import initBubbleCloud from "./components/bubble-cloud";
import initViewFilter from "./components/view-filter";
import initCtaButton from "./components/cta-button";
import initStatusHover from "./components/status-hover";
import initScrollingTicker from "./components/scrolling-ticker";
import initTagScroll from "./components/tag-scroll";
import initEasLogo from "./components/eas-logo";
import "./components/highcharts-init";

// Initialize components when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  initBurgerNav();
  initCustomSelect();
  initSectorDropdown();
  initPrevNextNav();
  initProposalCard();
  initProposalItem();
  initCardsProgress();
  initScrollingCards();
  initDonutCharts();
  initBubbleCloud();
  initViewFilter();
  initCtaButton();
  initStatusHover();
  initScrollingTicker();
  initTagScroll();
  initEasLogo();
});
